import React, { createContext, useRef, useContext } from 'react';
var CssContext = createContext(function () { });
export var useCssContext = function () { return useContext(CssContext); };
/**
 * This will generate link tags for each url passed to it exactly once.
 * The main use for this is with the Esi component that might return the same stylesheet links multiple
 * times over multiple Esi instances
 */
export var CssStore = function (_a) {
    var children = _a.children;
    // using a ref here prevents the whole react tree from rerendering on every stylesheet added here - no need for that
    var cssPathsRef = useRef([]);
    var addCssPath = function (csspath) {
        // the array is basically just a list of links already handled so we don't load the same path twice
        if (!cssPathsRef.current.includes(csspath)) {
            cssPathsRef.current.push(csspath);
            if (typeof window !== 'undefined' && typeof window.document !== 'undefined') {
                // we don't use helmet here as we want to bypass react completely, react shouldn't care here!
                var document_1 = window.document;
                var linkElem = document_1.createElement('link');
                linkElem.href = csspath;
                linkElem.type = 'text/css';
                linkElem.rel = 'stylesheet';
                linkElem.media = 'all';
                document_1.getElementsByTagName('head')[0].appendChild(linkElem);
            }
        }
    };
    return React.createElement(CssContext.Provider, { value: addCssPath }, children);
};
export default CssStore;
//# sourceMappingURL=index.js.map